// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wa-setup-modal-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
}

.wa-setup-modal-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1a1a1a;
}

.wa-setup-modal-intro {
  margin: 12px 0 20px;
  text-align: center;
  color: #555;
  font-size: 0.95rem;
  line-height: 1.5;
}

.wa-setup-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.wa-setup-option {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  background-color: #fff;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.wa-setup-option:hover {
  border-color: #5616ea;
  background-color: #f7f3ff;
}

.wa-setup-option-icon {
  flex-shrink: 0;
  font-size: 1.4rem;
  color: #5616ea;
}

.wa-setup-option-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
  min-width: 0;
}

.wa-setup-option-title {
  font-size: 1rem;
  font-weight: 600;
  color: #1a1a1a;
}

.wa-setup-option-desc {
  font-size: 0.85rem;
  color: #666;
  line-height: 1.4;
}

.wa-setup-option-arrow {
  flex-shrink: 0;
  font-size: 0.9rem;
  color: #9e9e9e;
}

.wa-setup-modal-actions {
  margin-top: 20px;
}

.wa-setup-manual-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.wa-setup-modal-actions-row {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/components/WhatsAppSetupModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gEAAgE;AAClE;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B","sourcesContent":[".wa-setup-modal-header {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 12px;\r\n  text-align: center;\r\n}\r\n\r\n.wa-setup-modal-title {\r\n  margin: 0;\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n  color: #1a1a1a;\r\n}\r\n\r\n.wa-setup-modal-intro {\r\n  margin: 12px 0 20px;\r\n  text-align: center;\r\n  color: #555;\r\n  font-size: 0.95rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.wa-setup-options {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.wa-setup-option {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n  width: 100%;\r\n  padding: 16px;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 10px;\r\n  background-color: #fff;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: border-color 0.15s ease, background-color 0.15s ease;\r\n}\r\n\r\n.wa-setup-option:hover {\r\n  border-color: #5616ea;\r\n  background-color: #f7f3ff;\r\n}\r\n\r\n.wa-setup-option-icon {\r\n  flex-shrink: 0;\r\n  font-size: 1.4rem;\r\n  color: #5616ea;\r\n}\r\n\r\n.wa-setup-option-text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.wa-setup-option-title {\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  color: #1a1a1a;\r\n}\r\n\r\n.wa-setup-option-desc {\r\n  font-size: 0.85rem;\r\n  color: #666;\r\n  line-height: 1.4;\r\n}\r\n\r\n.wa-setup-option-arrow {\r\n  flex-shrink: 0;\r\n  font-size: 0.9rem;\r\n  color: #9e9e9e;\r\n}\r\n\r\n.wa-setup-modal-actions {\r\n  margin-top: 20px;\r\n}\r\n\r\n.wa-setup-manual-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n}\r\n\r\n.wa-setup-modal-actions-row {\r\n  display: flex;\r\n  gap: 12px;\r\n  justify-content: flex-end;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
